import VueRouter from 'vue-router'

import Home from 'components/pages/Home'
import Directory from 'components/pages/Directory'

const routes = [
  { path: '/', component: Home },
  { path: '/dossier/:directoryId', component: Directory },
  { path: '*', redirect: '/' }
]

export default new VueRouter({
  routes,
  mode: 'history'
})



// WEBPACK FOOTER //
// ./app/src/router.js